import { useState } from 'react';
import AdminLayout from '../components/AdminLayout';
import { useAuth } from '../../../auth/AuthContext';
import { authService } from '../../../services/auth.service';

export default function ProfilePage() {
  const { user, login } = useAuth();
  const [name, setName] = useState(user?.name || '');
  const [email, setEmail] = useState(user?.email || '');
  const [saved, setSaved] = useState(false);
  const [saveError, setSaveError] = useState('');

  const [currentPassword, setCurrentPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [pwError, setPwError] = useState('');
  const [pwSuccess, setPwSuccess] = useState(false);

  const inputClass = "w-full px-4 py-2.5 text-sm rounded-xl border-2 border-rose-100 bg-rose-50/30 focus:outline-none focus:border-rose-300 transition-all";
  const labelClass = "block text-xs font-semibold text-gray-600 mb-1.5";

  const handleProfileSave = async () => {
    setSaveError('');
    try {
      await authService.updateProfile({ name, email });
      setSaved(true);
      setTimeout(() => setSaved(false), 2500);
    } catch {
      setSaveError('שגיאה בשמירת הפרטים');
    }
  };

  const handlePasswordSave = async () => {
    setPwError('');
    setPwSuccess(false);

    if (newPassword !== confirmPassword) {
      setPwError('הסיסמאות אינן תואמות');
      return;
    }
    if (newPassword.length < 6) {
      setPwError('הסיסמה חייבת להכיל לפחות 6 תווים');
      return;
    }
    if (!currentPassword) {
      setPwError('יש להזין את הסיסמה הנוכחית');
      return;
    }

    try {
      await authService.updatePassword({ current_password: currentPassword, new_password: newPassword });
      setCurrentPassword('');
      setNewPassword('');
      setConfirmPassword('');
      setPwSuccess(true);
      setTimeout(() => setPwSuccess(false), 3000);
    } catch (err: any) {
      setPwError(err.response?.data?.message || 'שגיאה בעדכון הסיסמה');
    }
  };

  return (
    <AdminLayout title="פרופיל" subtitle="ניהול פרטים אישיים והגדרות חשבון">
      {saved && (
        <div className="fixed top-6 left-1/2 -translate-x-1/2 z-50 flex items-center gap-2 px-5 py-3 bg-emerald-50 border-2 border-emerald-200 rounded-2xl text-emerald-600 text-sm font-semibold">
          <i className="ri-checkbox-circle-line text-base"></i>
          הפרטים נשמרו בהצלחה!
        </div>
      )}

      <div className="max-w-2xl space-y-5">
        {/* Profile Section */}
        <div className="bg-white rounded-2xl border-2 border-rose-100 overflow-hidden">
          <div className="flex items-center gap-3 px-5 py-4 border-b-2 border-rose-50">
            <div className="w-8 h-8 flex items-center justify-center rounded-xl bg-rose-50 text-rose-400">
              <i className="ri-user-line text-base"></i>
            </div>
            <h3 className="font-bold text-gray-800 text-sm">פרטים אישיים</h3>
          </div>
          <div className="p-5 space-y-4">
            <div>
              <label className={labelClass}>שם מלא</label>
              <input type="text" value={name} onChange={(e) => setName(e.target.value)} className={inputClass} />
            </div>
            <div>
              <label className={labelClass}>אימייל</label>
              <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} className={inputClass} />
            </div>
            {saveError && (
              <div className="flex items-center gap-2 px-4 py-2.5 bg-red-50 border-2 border-red-100 rounded-xl text-red-500 text-xs font-semibold">
                <i className="ri-error-warning-line text-sm"></i>
                {saveError}
              </div>
            )}
            <div className="flex justify-end">
              <button onClick={handleProfileSave}
                className="flex items-center gap-2 px-6 py-2.5 rounded-xl bg-rose-400 text-white text-sm font-bold hover:bg-rose-500 transition-all cursor-pointer whitespace-nowrap">
                <i className="ri-save-line text-base"></i>
                שמור שינויים
              </button>
            </div>
          </div>
        </div>

        {/* Password Section */}
        <div className="bg-white rounded-2xl border-2 border-rose-100 overflow-hidden">
          <div className="flex items-center gap-3 px-5 py-4 border-b-2 border-rose-50">
            <div className="w-8 h-8 flex items-center justify-center rounded-xl bg-rose-50 text-rose-400">
              <i className="ri-lock-password-line text-base"></i>
            </div>
            <h3 className="font-bold text-gray-800 text-sm">שינוי סיסמה</h3>
          </div>
          <div className="p-5 space-y-4">
            <div>
              <label className={labelClass}>סיסמה נוכחית</label>
              <input type="password" value={currentPassword} onChange={(e) => setCurrentPassword(e.target.value)} placeholder="הכנס סיסמה נוכחית..." className={inputClass} />
            </div>
            <div>
              <label className={labelClass}>סיסמה חדשה</label>
              <input type="password" value={newPassword} onChange={(e) => setNewPassword(e.target.value)} placeholder="לפחות 6 תווים..." className={inputClass} />
            </div>
            <div>
              <label className={labelClass}>אימות סיסמה</label>
              <input type="password" value={confirmPassword} onChange={(e) => setConfirmPassword(e.target.value)} placeholder="הכנס שוב את הסיסמה החדשה..." className={inputClass} />
            </div>
            {pwError && (
              <div className="flex items-center gap-2 px-4 py-2.5 bg-red-50 border-2 border-red-100 rounded-xl text-red-500 text-xs font-semibold">
                <i className="ri-error-warning-line text-sm"></i>
                {pwError}
              </div>
            )}
            {pwSuccess && (
              <div className="flex items-center gap-2 px-4 py-2.5 bg-emerald-50 border-2 border-emerald-200 rounded-xl text-emerald-600 text-xs font-semibold">
                <i className="ri-checkbox-circle-line text-sm"></i>
                הסיסמה עודכנה בהצלחה
              </div>
            )}
            <div className="flex justify-end">
              <button onClick={handlePasswordSave}
                className="flex items-center gap-2 px-6 py-2.5 rounded-xl bg-rose-400 text-white text-sm font-bold hover:bg-rose-500 transition-all cursor-pointer whitespace-nowrap">
                <i className="ri-lock-line text-base"></i>
                עדכן סיסמה
              </button>
            </div>
          </div>
        </div>
      </div>
    </AdminLayout>
  );
}
